import slideTypes from './slideTypes'
import actionTypes from 'redux/actions/actionTypes'

export default {
	'DRAW_IT/CANCEL_DRAW_IT_CONFIRMED': slideTypes.SLIDE_TYPE_ID_DRAW_IT,
	'GAME/CANCEL': slideTypes.SLIDE_TYPE_ID_TIME_TO_CLIMB,
	'GAME/CANCEL_CONFIRMED': slideTypes.SLIDE_TYPE_ID_TIME_TO_CLIMB,
	'OEQ/CANCEL_OEQ_CONFIRMED': slideTypes.SLIDE_TYPE_ID_OPEN_ENDED_QUESTION,
	'POLL/CANCEL_POLL_CONFIRMED': slideTypes.SLIDE_TYPE_ID_POLL,
	'QUIZ/CANCEL_QUIZ_CONFIRMED': slideTypes.SLIDE_TYPE_ID_QUIZ,
	'MATCHING_PAIRS_CT/CANCEL_MP_CONFIRMED': slideTypes.SLIDE_TYPE_ID_MATCHING_PAIRS,
	'FLOCABULARY/CLOSE_SELECTED': slideTypes.SLIDE_TYPE_ID_FLOCABULARY,
	'FLOCABULARY/LIMIT_REACHED_OVERLAY_DISMISS_SELECTED': slideTypes.SLIDE_TYPE_ID_FLOCABULARY,
	'FLOCABULARY/LIMIT_REACHED_OVERLAY_NUDGE_SELECTED': slideTypes.SLIDE_TYPE_ID_FLOCABULARY,
	[actionTypes.FLIPGRID_CREATION_TOOL_CANCEL]: slideTypes.SLIDE_TYPE_ID_FLIPGRID,
	[actionTypes.VIDEO_CANCEL_CONFIRMED]: slideTypes.SLIDE_TYPE_ID_VIDEO,
}
